<template>
  <!-- TODO: Je to dynamicky, potreba predelat, je to stejny jak bez benefit, ale podle id 3_months.svg -->
  <svg
    height="70"
    viewBox="0 0 63 70"
    width="63"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fill-rule="evenodd"
    >
      <path
        d="m62.222 35c0 19.33-15.688 35-35.039 35-10.972 0-20.762-5.036-27.183-12.917a30.492 30.492 0 0 0 7.812 1.011c16.857 0 30.526-13.654 30.526-30.492 0-11.847-6.766-22.122-16.641-27.171a34.526 34.526 0 0 1 5.486-.431c19.35 0 35.04 15.67 35.04 35"
        fill="#4f2b1b"
      />
      <path
        d="m10.54 41.56c2.56 0 4.66-.887 6.3-2.66s2.46-4.1 2.46-6.98c0-2.667-.673-4.793-2.02-6.38s-3.073-2.38-5.18-2.38c-1.627 0-3.293.627-5 1.88v-.72c0-2.453.347-4.313 1.04-5.58s1.64-1.9 2.84-1.9c1.6 0 2.64 1.28 3.12 3.84l4.68-.72c-.267-2.32-1.08-4.1-2.44-5.34s-3.173-1.86-5.44-1.86c-3.173 0-5.613 1.227-7.32 3.68s-2.56 6.027-2.56 10.72c0 4.56.853 8.1 2.56 10.62s4.027 3.78 6.96 3.78zm.2-4.68c-1.04 0-1.887-.68-2.54-2.04s-.98-3.28-.98-5.76v-.4c1.067-.773 2.08-1.16 3.04-1.16 1.093 0 1.947.413 2.56 1.24s.92 2.013.92 3.56c0 1.467-.267 2.593-.8 3.38s-1.267 1.18-2.2 1.18z"
        fill="#ee9f3f"
        fill-rule="nonzero"
      />
    </g>
  </svg>
</template>
